import { defineMessages } from 'react-intl'

export default defineMessages({
    title: {
        id: 'containers.SupplierPage.Tasks.title',
        defaultMessage: 'Title',
    },
    deadline: {
        id: 'containers.SupplierPage.Tasks.deadline',
        defaultMessage: 'Deadline',
    },
    price: {
        id: 'containers.SupplierPage.Tasks.price',
        defaultMessage: 'Price',
    },
    cost: {
        id: 'containers.SupplierPage.Tasks.cost',
        defaultMessage: 'Cost',
    },
    taskId: {
        id: 'containers.SupplierPage.Tasks.taskId',
        defaultMessage: 'Task Id',
    },
    orderId: {
        id: 'containers.SupplierPage.Tasks.orderId',
        defaultMessage: 'Order Id',
    },
    wordCount: {
        id: 'containers.SupplierPage.Tasks.wordCount',
        defaultMessage: 'Words',
    },
    customer: {
        id: 'containers.SupplierPage.Tasks.customer',
        defaultMessage: 'Company',
    },
    contact: {
        id: 'containers.SupplierPage.Tasks.contact',
        defaultMessage: 'Contact',
    },
    partner: {
        id: 'containers.SupplierPage.Tasks.partner',
        defaultMessage: 'Partner',
    },
    media: {
        id: 'containers.SupplierPage.Tasks.media',
        defaultMessage: 'Media',
    },
    prev: {
        id: 'containers.SupplierPage.Tasks.prev',
        defaultMessage: 'Prev',
    },
    next: {
        id: 'containers.SupplierPage.Tasks.next',
        defaultMessage: 'Next',
    }
})
